(function($){

    function YouChoose() {
        // DOM elements
        this.dom = {
            $wrap: $('.youchoose'),
            $product: $('.youchoose-product-item'),
            $preview: $('.youchoose-preview-item'),
            $remaining: $('.youchoose-remaining'),
            $checkoutButton: $('.youchoose-checkout-button'),
            $overlay: $('.youchoose-overlay'),
            $items: $('.youchoose-items'),
            $toggle: $('[data-toggle]'),
            $item: $('[data-id]'),
            $action: $('[data-action]'),
            $filter: $('[data-filter]'),
        };

        // Screen size
        this.size = {
            xs: $('.is-size-xs').is(':visible'),
            sm: $('.is-size-sm').is(':visible'),
            md: $('.is-size-md').is(':visible'),
            lg: $('.is-size-lg').is(':visible'),
        };

        // Template data
        this.bundleProduct = JSON.parse(this.dom.$wrap.attr('data-product'));
        this.bundleVariant = JSON.parse(this.dom.$wrap.attr('data-variant'));
        this.count = this.dom.$wrap.attr('data-count');

        // Build the slots
        this.ids = [];
        this.titles = [];
        for (var i=0; i<this.count; i++) {
            this.ids.push(null);
        }

        // Event listeners
        this.init();
    };

    YouChoose.prototype.init = function() {
        var self = this;

        // Collections have a query limit of 50 / 250 when inside the theme layout,
        // so instead we're going to query the custom youchoose-data template
        // this allows us to query up to 1000 products per collection
        // @ref https://community.shopify.com/c/Shopify-Design/50-Product-limit-on-collections/td-p/204693
        $.get('/products/' + this.bundleProduct.handle + '?view=youchoose-data', function(html) {
            self.dom.$items.html(html);
        });

        // Add padding to prevent the overlay from covering the footer
        if (this.size.lg) {
            $('html').css('padding-bottom', this.dom.$overlay.outerHeight());
        }

        // Trigger filter state
        this.dom.$filter.on('keyup', function(e) {
            self.filter($(this).val());
        });

        // Toggle the overlay active state
        $('body').on('click', this.dom.$toggle.selector, function(e) {
            e.preventDefault();
            self.setOverlayState();
        });

        // Do an action on click
        $('body').on('click', this.dom.$action.selector, function(e) {
            e.preventDefault();

            var action = $(this).attr('data-action');
            var item   = $(this).closest(self.dom.$item.selector);

            if (action == 'add') {
                self.add(item);
            } else if (action == 'remove') {
                self.remove(item);
            } else if (action == 'checkout') {
                self.checkout();
            }

            // Toggle the overlay if the count is maxed
            if (self.isCountMaxed()) {
                self.setOverlayState();
            }

            self.setRemainingState();
            self.setCheckoutState();
        });
    };

    YouChoose.prototype.add = function(item) {
        // Exit if we've hit the max
        if (this.isCountMaxed()) {
            console.log('Item max is reached.');
            return;
        }

        var id = item.attr('data-id');
        var title = item.attr('data-title');
        var index = this.getIndexOf(null);

        if (index < 0) {
            return;
        }

        // Set the product / preview DOM
        this.setItemState(id, index, 'add');

        // Add to the id array
        this.ids[index] = id;
        this.titles[index] = title;

        // Disabled the button if the stock is maxed
        if (this.isStockMaxed(id, item.attr('data-stock'))) {
            item.find('[data-action=add]').attr('disabled', 1).css('visibility', 'hidden');
        }
    };

    YouChoose.prototype.remove = function(item) {
        // Exit if less than 0
        if (this.getIds().length == 0) {
            console.log('Item min is reached.');
            return;
        }

        var id = item.attr('data-id');
        var index = item.attr('data-index') || this.getIndexOf(id);

        if (index < 0) {
            return;
        }

        // Add to the cart preview
        this.setItemState(id, index, 'remove');

        // Remove the key from the array
        this.ids[index] = null;
        this.titles[index] = null;

        // Enable the add button if the stock is maxed
        if (!this.isStockMaxed(id, item.attr('data-stock'))) {
            item.find('[data-action=add]').removeAttr('disabled').css('visibility', 'visible');
        }
    };

    YouChoose.prototype.checkout = function() {
        if (!this.isCountMaxed()) {
            console.log('Item max is not reached.');
            return;
        }

        var data = {
            id: this.bundleVariant.id,
            properties: this.getProperties(),
            quantity: 1,
        };

        $.getJSON('/cart/add.js', data, function(response) {
            document.location.href = '/cart';
        });
    };

    YouChoose.prototype.filter = function(value) {
        // Get the products
        var products = $(this.dom.$product.selector);

        // Sanitize the value
        var keyword = value.toLowerCase().trim();

        // If no keyword show all products
        if (!keyword) {
            products.removeClass('hidden');
            return;
        }

        products.each(function() {
            // Get the title
            var title = $(this).attr('data-title').toLowerCase();

            if (title.indexOf(keyword) > -1) {
                $(this).removeClass('hidden');
            } else {
                $(this).addClass('hidden');
            }
        });
    };

    YouChoose.prototype.setItemState = function(id, index, action) {
        // Find the DOM elements
        var product = $(this.dom.$product.selector + '[data-id=' + id + ']');
        var preview = $(this.dom.$preview[index]);

        var counter = product.find('.spinner-count span');
        var count = parseInt(counter.html());

        if (action == 'add') {
            product.addClass('active');
            count++;
        } else if (action == 'remove') {
            product.removeClass('active');
            count--;
        }

        // Set the count
        counter.html(count);

        if (preview.length) {
            if (action == 'add') {
                preview.addClass('active');
                preview.attr('data-id', id);
                preview.find(this.dom.$preview.selector + '-title').html(product.attr('data-title'));
                preview.find(this.dom.$preview.selector + '-image').css('background-image', 'url(' + product.attr('data-image') + ')');
            } else if (action == 'remove') {
               preview.removeClass('active');
               preview.attr('data-id', '');
               preview.find(this.dom.$preview.selector + '-title').html('');
               preview.find(this.dom.$preview.selector + '-image').css('background-image', '');
           }
        }
    };

    YouChoose.prototype.setCheckoutState = function() {
        if (this.isCountMaxed()) {
            this.dom.$checkoutButton.removeAttr('disabled');
        } else {
            this.dom.$checkoutButton.attr('disabled', 1);
        }
    };

    YouChoose.prototype.setRemainingState = function() {
        this.dom.$remaining.html(this.count - this.getIds().length);
    };

    YouChoose.prototype.setOverlayState = function() {
        // Toggle the overlay
        this.dom.$overlay.toggleClass('active');

        // Prevent the body from scrolling
        if (!this.size.lg) {
            if (this.dom.$overlay.hasClass('active')) {
                $('html').css('overflow', 'hidden');
            } else {
                $('html').css('overflow', 'auto');
            }
        }
    };

    YouChoose.prototype.isCountMaxed = function() {
        return this.getIds().length == this.count;
    };

    YouChoose.prototype.isStockMaxed = function(id, stock) {
        // Count the number of instances
        var count = this.getIds().reduce(function(n, val) {
            return n + (val === id);
        }, 0);

        if (count >= stock) {
            return true;
        }

        return false;
    };

    YouChoose.prototype.getIds = function() {
        return this.ids.filter(function(item) {
            if (item) { return item; };
        });
    };

    YouChoose.prototype.getIndexOf = function(id) {
        return this.ids.indexOf(id);
    };

    YouChoose.prototype.getProperties = function() {
        var properties = {};

        for (var i=0; i<this.titles.length; i++) {
            // Get the label
            var label = this.getIndexLabel(i) + ' Choice';

            // Capitalize the first character
            label = label.charAt(0).toUpperCase() + label.slice(1);

            properties[label] = this.titles[i];
        }

        return properties;
    };

    YouChoose.prototype.getIndexLabel = function(index) {
        var special = ['zeroth','first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth', 'eleventh', 'twelfth', 'thirteenth', 'fourteenth', 'fifteenth', 'sixteenth', 'seventeenth', 'eighteenth', 'nineteenth'];
        var deca = ['twent', 'thirt', 'fort', 'fift', 'sixt', 'sevent', 'eight', 'ninet'];

        // Increase the index by one
        index++;

        if (index < 20) {
           return special[index];
        }

        if (index % 10 === 0) {
            return deca[Math.floor(index / 10) - 2] + 'ieth';
        };

        return deca[Math.floor(index / 10 ) - 2] + 'y-' + special[index % 10];
    };

    var youchoose = new YouChoose();

})(jQuery);
